import * as S from './styles'

export const DataLine = ({ label, value }: DataLineProps) => {
  return (
    <S.DataContainer align="center">
      <S.LabelText variant="emphasis" color="var(--sl-fg-base-soft)">
        {label}
      </S.LabelText>
      <S.LabelText variant="emphasis">{value}</S.LabelText>
    </S.DataContainer>
  )
}
